import React, { Component, Fragment, BaseSyntheticEvent } from "react";
import { observer } from "mobx-react";
import { CQMasterDataStore } from "../../../../../store/cq-master-data.store";
import { TemplateSFObjectStore } from "../../../../../store/models/template-object.model";
import GridTemplateConfigurationController from "../../grid-template-config.controller";
import { Utility } from "../../../../../common/utility";
import { CQCombobox, generateComboboxOptions } from "../../../../../common/cq-inputs";

class CustomComponent extends Component<any, any> {
    private templateConfigCtrl: GridTemplateConfigurationController;
    private cqUtilityClass: Utility;
    
	constructor(props: {
        selectedTemplateName: string;
		selectedCustomComponent: any;
	}) {
        super(props);
		this.templateConfigCtrl = new GridTemplateConfigurationController();
        this.cqUtilityClass = new Utility();
        
		const { label, groupName } = this.props.selectedCustomComponent;
		const fieldsToDisplay =
			CQMasterDataStore.GridObject.gridComponentConfigView.fieldsToDisplay;
		let fieldToDisplay = fieldsToDisplay.filter(
			(fieldToDisplay: any, index: number) =>
				fieldToDisplay.label === label && fieldToDisplay.groupName === groupName
		);

		this.state = {
			showFields: fieldToDisplay[0].fields.length > 0 ? true : false,
			fields: fieldToDisplay[0].fields,
			isApplyRuleModalVisisble: false,
			selectedIndex: 0,
            showReferenceField: fieldToDisplay[0].fields.map((fields: any) => false),
            referenceFieldObj: {},
            shouldRenderComponent: fieldToDisplay[0].hasOwnProperty("isDeleted") && fieldToDisplay[0].isDeleted === true ? true : false
		};
	}

	componentDidMount() {
		const fieldsToDisplay =
			CQMasterDataStore.GridObject.gridComponentConfigView.fieldsToDisplay;
		let fieldToDisplay = fieldsToDisplay.filter(
			(fieldToDisplay: any, index: number) =>
				fieldToDisplay.label === this.props.selectedCustomComponent.label &&
				fieldToDisplay.groupName ===
					this.props.selectedCustomComponent.groupName
		);
		fieldToDisplay[0].fields.length > 0 &&
			fieldToDisplay[0].fields.forEach(async (field: any, index: number) => {
				const filterFieldToDisplayValues = await this.filterFieldToDisplayValues();
				const selectedObject = filterFieldToDisplayValues.find(
					(filterFieldToDisplayValue: any) =>
						filterFieldToDisplayValue.name === field.fieldInfo
				);
				this.selectedFieldsToDisplayLeft(selectedObject, index);
			});
	}

	componentDidUpdate(prevProps: {
		selectedTemplateName: string;
		selectedCustomComponent: any;
	}) {
		const prevProp = { ...prevProps.selectedCustomComponent };
		const prop = { ...this.props.selectedCustomComponent };
		if (
			(prevProp.label !== prop.label ||
				prevProp.groupName !== prop.groupName) &&
			prevProp.type === prop.type && (!prop.hasOwnProperty('isDeleted') || prop.isDeleted !== true)
		) {
			const fieldsToDisplay =
				CQMasterDataStore.GridObject.gridComponentConfigView.fieldsToDisplay;
			let fieldToDisplay = fieldsToDisplay.filter(
				(fieldToDisplay: any, index: number) =>
					fieldToDisplay.label === prop.label &&
					fieldToDisplay.groupName === prop.groupName
			);

			this.setState({
				showFields: fieldToDisplay[0].fields.length > 0 ? true : false,
				fields: fieldToDisplay[0].fields,
				isApplyRuleModalVisisble: false,
				selectedIndex: 0,
				showReferenceField: fieldToDisplay[0].fields.map(
					(fields: any) => false
                ),
                shouldRenderComponent: fieldToDisplay[0].hasOwnProperty("isDeleted") && fieldToDisplay[0].isDeleted === true ? true : false
			});

			fieldToDisplay[0].fields.length > 0 &&
				fieldToDisplay[0].fields.forEach(async (field: any, index: number) => {
					const filterFieldToDisplayValues = await this.filterFieldToDisplayValues();
					const selectedObject = filterFieldToDisplayValues.find(
						(filterFieldToDisplayValue: any) =>
							filterFieldToDisplayValue.name === field.fieldInfo
					);
					this.selectedFieldsToDisplayLeft(selectedObject, index);
				});
		}
	}

	showReferenceFieldHandler = (index: number) => {
		const showReferenceField = this.cqUtilityClass.createObjectDeepCopy(this.state.showReferenceField);
		showReferenceField[index] = !this.state.showReferenceField[index];
		this.setState({ showReferenceField });
	};

	addReferenceField = (referenceObj: any, index: number) => {
        const fields = this.cqUtilityClass.createObjectDeepCopy(this.state.fields);
        const selectedObject = this.filterFieldToDisplayValues().find(
			(field: any) => field.name === fields[index].fieldInfo
		);
        fields[index].displayField = selectedObject.relationshipName + '.' + referenceObj.name;   
		fields[index].displayType = "hyperLink";
		fields[index].referenceLabel = this.getLabel(referenceObj.label || '');

		const showReferenceField = [...this.state.showReferenceField];
		showReferenceField[index] = !showReferenceField[index];

        this.setState({ fields, showReferenceField }, () => {
            this.updateStores();
        });
	};

	fieldChangeHandler = (
		e: BaseSyntheticEvent,
		index: number
	) => {
		let selectedObject = this.filterFieldToDisplayValues().find(
			(field: any) => field.name === e.target.value
		);
		const fields = this.cqUtilityClass.createObjectDeepCopy(this.state.fields);

		if(e.target.value === '') {
			fields[index] = { fieldInfo: "" };
			selectedObject = {
				referenceTo: []
			}
		} else {
			fields[index].fieldInfo = e.currentTarget.value;
			fields[index].label = selectedObject.label;
		}

        //deleting referenceField keys
        delete fields[index].displayField;
        delete fields[index].displayType;
        delete fields[index].referenceLabel;

		this.setState({ fields }, () => {
			this.selectedFieldsToDisplayLeft(selectedObject, index);
			this.updateStores();
		});
	};

	deleteLookupFilter = (index: number) => {
		let fields = this.cqUtilityClass.createObjectDeepCopy(this.state.fields);

		fields = fields.filter((field: any, key: number) => key !== index);
		let showFields = this.state.showFields;

		const showReferenceField = [...this.state.showReferenceField];
		showReferenceField.splice(index, 1);

		if (fields.length === 0) {
			showFields = false;
		}
		this.setState({ fields, showFields, showReferenceField }, () => {
			this.updateStores(index);
		});
	};

	updateStores = (index?: number) => {
		const { label, type, groupName } = this.props.selectedCustomComponent;
		
		let ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
		let gridObject: any;
		if (ruleElements.hasOwnProperty("gridObject")) {
            gridObject = { ...ruleElements.gridObject };
            let fieldsVisibilityRules = gridObject.gridComponentConfigView.fieldsVisibilityRules;

            if(index !== undefined && index > -1 && fieldsVisibilityRules){
                fieldsVisibilityRules = fieldsVisibilityRules.map((field: any) => {
                    if (
						field.label === label &&
						field.type === type &&
						field.groupName === groupName
					) {
                        field.fields.splice(index, 1);
                    }
                    return field;
                });

                gridObject.gridComponentConfigView.fieldsVisibilityRules = fieldsVisibilityRules;
            }

			const fieldsToDisplay = gridObject.gridComponentConfigView.fieldsToDisplay.map(
				(field: any, key: number) => {
					if (
						field.label === label &&
						field.type === type &&
						field.groupName === groupName
					) {
						field.fields = this.state.fields;
					}
					return field;
				}
			);

			gridObject.gridComponentConfigView.fieldsToDisplay = fieldsToDisplay;
			ruleElements.gridObject = gridObject;
		}

		CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(
			this.props.selectedTemplateName,
			"ruleElements",
			ruleElements
		);
		CQMasterDataStore.GridObject.updateGridField(
			"gridComponentConfigView",
			gridObject.gridComponentConfigView
        );
        
		let displayFieldsArray = Array.from(
			new Set(gridObject.gridComponentConfigView.fieldsToDisplay)
		);
		this.templateConfigCtrl.updateFieldValue(
			"fields",
			displayFieldsArray,
			this.props.selectedTemplateName
		);
    };

	private selectedFieldsToDisplayLeft = (fieldValue: any, index: number) => {
        const copyReferenceFieldObj = this.cqUtilityClass.createObjectDeepCopy(this.state.referenceFieldObj);
        if(!copyReferenceFieldObj.hasOwnProperty(fieldValue.name)){
            let additionalFieldObjCopy: any;
            if (fieldValue.referenceTo.length > 0 && fieldValue.name.toLowerCase() !== 'ownerid') {
                this.templateConfigCtrl.getReferenceObjectFields(
                    fieldValue.referenceTo[0],
                    false,
                    true
                );
                additionalFieldObjCopy = TemplateSFObjectStore.referenceObjectFields.fields;
            } else {
                additionalFieldObjCopy = [];
            }
            copyReferenceFieldObj[fieldValue.name] = additionalFieldObjCopy;
        }
        this.setState({ referenceFieldObj: copyReferenceFieldObj });
	};

	addField = () => {
		const fields = this.cqUtilityClass.createObjectDeepCopy(this.state.fields);
		fields.push({ fieldInfo: "" });
		this.setState({ fields, showFields: true });
	};

	private filterFieldToDisplayValues = () => {
		let objectFieldsList = JSON.parse(
			JSON.stringify(TemplateSFObjectStore.standardObjectFields.fields)
		);
		return objectFieldsList;
	};

	/**
	 * generated refined combobox options from raw options
	 * @param options raw options which need to be refined for cq-combobox
	 * @returns refined combobox options
	 */
	generateComboboxOptionFields = (options: any[]) => 
		generateComboboxOptions(
			options,
			{
				label: 'label',
				value: 'name'
			},
			(option) => option.label + ' - ' + option.name
		);
	
	/**
	 * gets the label of the field
	 * @param rawLabel label in the format <label> - <apiName>
	 * @returns <label> label of the field
	 */
	getLabel = (rawLabel: string) => rawLabel.split(' - ')[0];

	/**
	 * UI
	 */
	private selectFields = () => {
		const that = this;
		const fields = this.state.fields.map(
			(selectedLookupField: any, index: number) => {
				return (
					<div key={index} className="slds-grid slds-wrap slds-p-top_small">
						<div className="slds-col  slds-size_1-of-1">
							<div className="slds-grid slds-gutters">
								{index + 1}
								<div className="slds-col slds-size_4-of-5">
									<CQCombobox
										config= {{
											variation: "inline-listbox",
											isDisabled: false
										}}
										label= {{
											label: '',
											placeholder: ''
										}}
										onActionPerformed= {(actionType, option) => {
											if(typeof option === 'string') {
												return;
											}

											this.fieldChangeHandler(
												{
													target: {
														value: option[0] ? option[0].value : '',
														name: 'objLayoutFieldsArray'
													},
													currentTarget: {
														value: option[0] ? option[0].value : '',
														name: 'objLayoutFieldsArray'
													}
												} as BaseSyntheticEvent, 
												index
											)
										}}
										options= {this.generateComboboxOptionFields(that.filterFieldToDisplayValues())}
										limit= {this.generateComboboxOptionFields(that.filterFieldToDisplayValues()).length}
										key= 'mainOptionFields'
										value= {selectedLookupField.fieldInfo}
									/>
								</div>
								<div className="slds-col slds-size_1-of-5 slds-p-horizontal_none slds-p-top_xx-small">
									<span className="slds-col slds-p-right_none">
										<button
											className="slds-button slds-text-color_destructive"
											role="delete-select"
											onClick={() => {
												this.deleteLookupFilter(index);
											}}
										>
											<i className="cq-icon-delete cq-2x"></i>
										</button>
									</span>
								</div>
							</div>
						</div>
						<div className="slds-col  slds-size_1-of-1">
							{this.state.referenceFieldObj[selectedLookupField.fieldInfo] &&
								this.state.referenceFieldObj[selectedLookupField.fieldInfo].length > 0 && (
									<CQCombobox
										config= {{
											variation: 'inline-listbox',
											isDisabled: false
										}}
										label= {{
											label: '',
											placeholder: 'Please Select Option'
										}}
										onActionPerformed= {(actionType, option) => {
											if(typeof option === 'string') {
												return;
											}

											this.addReferenceField(
												option[0] || {},
												index
											)
										}}
										options= {
											this.generateComboboxOptionFields(
												this.state.referenceFieldObj[selectedLookupField.fieldInfo]
											)
										}
										limit= {this.generateComboboxOptionFields(
											this.state.referenceFieldObj[selectedLookupField.fieldInfo]
										).length}
										value= {
											selectedLookupField.displayField
											? selectedLookupField.displayField.split(
													"."
												)[1]
											: ""
										}
										key= "referenceOptionFields"
									/>
								)}
						</div>
					</div>
				);
			}
		);

		return fields;
	};

	render() {
		const { selectedCustomComponent } = this.props;
		return (
			<Fragment>
				<div className="slds-col config-sidebar full-height">
					<div className="bg-white full-height slds-p-around_small">
						<div className="slds-grid slds-grid_vertical full-height">
                            {
                                // this.state.shouldRenderComponent
                                selectedCustomComponent.hasOwnProperty('isDeleted') && selectedCustomComponent.isDeleted === true
                                    ?
                                `Please Select Field or Action`
                                    :
                                <Fragment>
                                    <h2 className="slds-text-heading_small slds-m-bottom_medium">
                                        Compound Field
                                    </h2>
                                    <div className="slds-text-title slds-m-bottom_x-small"> Label: {selectedCustomComponent.label} </div>
                                    <div className="slds-text-title slds-m-bottom_x-small"> Group Name: {selectedCustomComponent.groupName} </div>

                                    <button
                                        className="slds-button slds-button_brand"
                                        onClick={this.addField}
                                    >
                                        Add Field
                                    </button>
                                    {this.state.showFields && this.selectFields()}
                                </Fragment>
                            }
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

export const GridCustomComponent = observer(CustomComponent);
